import number from "@/data/number";

export default [
  {
    key: "onKey",
    label: "field.onKey",
    rules: "required",
    type: "single-selection",
    reduce: true,
    rows: "5",
    cols: 12,
    options: number,
  },
  {
    key: "localeCode",
    label: "field.localeCode",
    rules: "required",
    type: "single-selection",
    selectionKey: "language",
    reduce: true,
    rows: "5",
    cols: 12,
    options: [],
  },
  {
    key: "voice",
    label: "field.voice",
    initKey: "voice",
    rules: "required",
    type: "single-audio",
    rows: "5",
    cols: 12,
  },
  {
    key: "backVoice",
    label: "field.backVoice",
    labelSuffix: "field.backVoiceSuffix",
    initKey: "backVoice",
    rules: "required",
    type: "single-audio",
    rows: "5",
    cols: 12,
  },
  {
    key: "waitingSound",
    label: "field.waitingSound",
    initKey: "waitingSound",
    type: "single-audio",
    rows: "5",
    cols: 12,
  },
  {
    key: "ringTune",
    label: "field.ringTune",
    initKey: "ringTune",
    type: "single-audio",
    rows: "5",
    cols: 12,
  },
  {
    key: "memo",
    label: "field.memo",
    rules: "required",
    type: "textarea",
    rows: "2",
    cols: 12,
  },
];
